import React from 'react';
import classnames from 'classnames';

import classes from './PricingTable.scss';

type Props = {
    title: string;
    columnTitle1: string;
    columnTitle2: string;
    columnTitle3?: string;
    columnData1: string[];
    columnData2: string[];
    columnData3?: (string | JSX.Element)[];
    additionalInfo?: string;
    tableSize?: 'Wide' | 'MaxSpace';
};

export const PricingTable: React.FC<Props> = ({
    title,
    columnTitle1,
    columnTitle2,
    columnTitle3,
    columnData1,
    columnData2,
    columnData3,
    additionalInfo,
    tableSize,
}) => {
    const threeRowTable = Boolean(columnTitle3 || columnData3);

    return (
        <div
            className={classnames(classes.pricingTableContainer, {
                [classes.pricingTableWide]: tableSize && tableSize === 'Wide',
                [classes.pricingTableMax]: tableSize && tableSize === 'MaxSpace',
            })}
            data-testid="pricingTable"
        >
            <h3 className={classes.tableHeader}>
                {title} <span className={classes.additionalInfo}>{additionalInfo}</span>
            </h3>
            <div
                className={classnames(classes.tableRow, classes.headerRow, {
                    [classes.threeColumnHeaderRow]: threeRowTable,
                })}
            >
                <div className={classnames(classes.tableCell, classes.indentedCell)}>{columnTitle1}</div>
                <div className={classes.tableCell}>{columnTitle2}</div>
                {columnTitle3 && <div className={classes.tableCell}>{columnTitle3}</div>}
            </div>

            {columnData1.map((dataItem) => {
                const index = columnData1.indexOf(dataItem);

                return (
                    <div
                        key={dataItem}
                        className={classnames(classes.tableRow, {
                            [classes.threeColumnRow]: threeRowTable,
                        })}
                    >
                        <div className={classnames(classes.tableCell, classes.indentedCell)}>{columnData1[index]}</div>
                        <div
                            className={classnames(classes.tableCell, {
                                [classes.paddedCell]: threeRowTable,
                            })}
                        >
                            {columnData2[index]}
                        </div>
                        {columnData3 && <div className={classes.tableCell}>{columnData3[index]}</div>}
                    </div>
                );
            })}
        </div>
    );
};
